import { useGet } from 'common/hooks/useApi'
import { IPaginatedResponse } from 'common/types/api.types'
import { Dispatch, SetStateAction } from 'react'
import { toast } from 'react-toastify'
import { ApiPathsJobs } from '../../jobs.service'
import { IJob } from '../../jobs.types'
import { JobCard } from '../JobCard'
import { IJobsListQuery } from './CommunityJobs'

interface IProps {
  queryString: string
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
}
export const CommunityJobsList = ({ queryString, setQuery }: IProps) => {
  const { data: paginatedJobs } = useGet<IPaginatedResponse<IJob[]>>(ApiPathsJobs.getPublicJobs(queryString), {
    onError: (err) => {
      console.log({ err })
      toast.error('Could not fetch jobs')
    },
    onSuccess: (data) => {
      // Set the next page so the load more button can use it
      setQuery((c) => ({
        ...c,
        nextQuery: data.links.next || '',
        totalItems: data.meta.totalItems,
        loadedItems: c.loadedItems + data.data.length,
      }))
    },
  })

  return (
    <>
      {paginatedJobs?.data.map((job) => (
        <JobCard key={job.id} job={job} />
      ))}
    </>
  )
}
